import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsAbortUnabort extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForAbortJob: "/api/v1/portal/jobs/abort-job/",
      apiUrlForUnabortJob: "/api/v1/portal/jobs/unabort-job/",
      abortJobReason: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  abortJob() {
    if(!this.state.abortJobReason){
      $('#infomodallabel').html('Add Reason');
      $('#infomodal .modal-body').html('Please add reason to Abort job.');
      $('#infomodal').modal();
      return false;
    }
    return fetch(
      this.state.apiUrlForAbortJob+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        body: JSON.stringify({abortion_reason: this.state.abortJobReason}),
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
          "Content-Type": 'application/json',
        },
      }
    ).then((responseText) => {
      this.setState({abortJobReason: null});
      }
    );
  }
  unabortJob() {
    return fetch(
      this.state.apiUrlForUnabortJob+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }  
  abortJobReasonData(e){
    this.setState({
        abortJobReason: e.target.value
      });
  }

  render() {
    return(
      <span>
        {(this.state.data.status !== 'aborted') ?
          <div className="abort_reason_div">
            <button className="btn btn-lg btn-warning"
                    onClick={() => {
                      this.abortJob(this.state.data.id)
                    }}>
              <i className="fa fa-ban"></i>&nbsp;
              Abort Job
            </button>
            <textarea name="abortion_reason" value={this.state.abortJobReason || ''} onChange={e => this.abortJobReasonData(e)} placeholder="Enter Reason"></textarea>
          </div>
          :
          <div className="abort_reason_div">
            <button className="btn btn-lg btn-warning"
                    onClick={() => {
                      this.unabortJob(this.state.data.id)
                    }}>
              <i className="fa fa-circle"></i>&nbsp;
              Unabort Job
            </button>
            <div className="aborted_job_details">
              <p>
                <strong>Aborted By : </strong>
                {(this.state.data.aborted_by && this.state.data.aborted_by.full_name)?this.state.data.aborted_by.full_name:null}
              </p>
              <p>
                <strong>Aborted Time : </strong>
                {this.state.data.aborted_at}
              </p>
              <p>
                <strong>Abortion Reason : </strong>
                {this.state.data.abortion_reason}
              </p>
            </div>
          </div>
        }
    </span>
    )
  }
}